export default __webpack_public_path__ + "static/char-thumb-29-0d89979118ba449b3af009571e9a5909.png";